<template>
	<div id="page-user-edit">
		<bread-crumbs
			:title="
				activeTab != 0 && !alarmData.id
					? $t('Crud.Create') + ' ' + $t('Alarm.SpeedAlarm')
					: activeTab != 0 && alarmData.id
					? $t('Crud.Update') + ' ' + $t('Alarm.SpeedAlarm')
					: $t('Alarm.SpeedAlarm')
			"
			:subTitle="
				activeTab != 0 && !alarmData.id
					? $t('general.SubtitleRadiusCreate')
					: activeTab != 0 && alarmData.id
					? $t('general.SubtitleRadiusUpdate')
					: ($t('general.SubtitleAlarmSchedule') +
							' ' +
							$t('general.SubtitleAlarmSchedule1') +
							' ' +
							$t('Alarm.Speed') +
							' ' +
							$t('general.SubtitleAlarmSchedule2'))
					  | upperAndLowerFilter
			"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		/>
		<vx-card>
			<div slot="no-body" class="tabs-container px-6 pt-6">
				<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
					<vs-tab :label="$t('Alarm.AlarmList')" icon-pack="feather" icon="icon-list">
						<div class="tab-text">
							<speed-alarm-list
								v-if="alarmReadPermission"
								class="mt-4"
								@selectedAlarmEmit="selectedAlarmEmit"
							/>
							<not-permission v-else></not-permission>
						</div>
					</vs-tab>

					<vs-tab :label="nameTabOne" icon-pack="feather" icon="icon-info">
						<div class="tab-text">
							<InputForm
								v-if="alarmCreatePermission && !alarmData.id"
								ref="alarmFormRef"
								class="mt-4"
								:data="alarmData"
								type="AlarmSpeed"
								@changeActiveTabEmit="changeActiveTab"
								@handleSubmitEmit="handleSubmit"
								:triggerCleanDates="triggerCleanDates"
							/>
							<InputForm
								v-else-if="alarmUpdatePermission && alarmData.id"
								ref="alarmFormRef"
								class="mt-4"
								:data="alarmData"
								type="AlarmSpeed"
								@changeActiveTabEmit="changeActiveTab"
								@handleSubmitEmit="handleSubmit"
								:triggerCleanDates="triggerCleanDates"
								:duplicate="duplicate"
							/>
							<not-permission v-else></not-permission>
						</div>
					</vs-tab>
				</vs-tabs>
			</div>
		</vx-card>
	</div>
</template>

<script>
import moduleAlarm from "@/store/alarm/moduleAlarm.js";
import AlarmSpeed from "@/models/AlarmSpeed";
import SpeedAlarmList from "./SpeedAlarmList.vue"; // Import the SpeedAlarmList component
import NotPermission from "@/views/pages/NotPermission.vue";
import InputForm from "../InputForm.vue";

export default {
	components: {
		SpeedAlarmList, // Register the SpeedAlarmList component
		NotPermission,
		InputForm,
	},
	data() {
		return {
			alarmData: new AlarmSpeed({}),
			user_not_found: false,
			activeTab: 0,
			triggerCleanDates: 0,
			duplicate: false,
		};
	},
	computed: {
		nameTabOne() {
			return this.alarmData.id ? this.$t("Alarm.UpdateAlarm") : this.$t("Alarm.CreateAlarm");
		},
		alarmReadPermission() {
			return this.$store.getters.checkPermission("ALARMS_R");
		},
		alarmCreatePermission() {
			return this.$store.getters.checkPermission("ALARMS_C");
		},
		alarmUpdatePermission() {
			return this.$store.getters.checkPermission("ALARMS_U");
		},
	},
	watch: {
		activeTab(tabNum) {
			if (tabNum === 0) {
				this.alarmData = new AlarmSpeed({});
			}
		},
	},
	methods: {
		validateSpeed(speed) {
			if (speed < 1 || speed > 200) {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alarm.Speed"),
					text: this.$t("Alarm.ValidSpeed"),
				});
				return false;
			}
			return true;
		},

		handleSubmit(data, update, duplicate = false) {
			this.alarmData = data;
			this.alarmData.speed = parseInt(data.speed);

			if (!this.validateSpeed(this.alarmData.speed)) {
				return;
			}

			this.$refs.alarmFormRef.openLoadingBtn();
			if (update && !duplicate) {
				this.updateSpeedAlarm();
			} else {
				this.createSpeedAlarm();
			}
		},

		async createSpeedAlarm() {
			try {
				await this.$store.dispatch("moduleAlarm/createSpeedAlarm", this.alarmData);
				this.$vs.notify({
					color: "success",
					title: this.$t("Alarm.TitleConfirmAlarmCreate"),
					text: this.$t("Alarm.TextConfirmAlarmCreate"),
				});
				this.changeActiveTab(0);
			} catch (error) {
				this.$refs.alarmFormRef.closeLoadingBtn();
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
				console.error(error);
				this.triggerCleanDates += 1;
			}
		},

		async updateSpeedAlarm() {
			try {
				await this.$store.dispatch("moduleAlarm/updateSpeedAlarm", this.alarmData);
				this.$vs.notify({
					color: "success",
					title: this.$t("Alarm.TitleConfirmAlarmUpdate"),
					text: this.$t("Alarm.TextConfirmAlarmUpdate"),
				});
				this.changeActiveTab(0);
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
				console.error(error);
				this.triggerCleanDates += 1;
			}
		},

		selectedAlarmEmit(alarm, duplicate = false) {
			this.alarmData = new AlarmSpeed(alarm);
			this.activeTab = 1;
			this.duplicate = duplicate;
		},
		changeActiveTab(tabNum) {
			this.activeTab = tabNum;
		},
	},
	created() {
		if (!moduleAlarm.isRegistered) {
			this.$store.registerModule("moduleAlarm", moduleAlarm);
			moduleAlarm.isRegistered = true;
		}
	},
};
</script>
